export enum ModelTypes {
  LICENSE = 'upload_license',
  AOI = 'aoi_keyinfo',
  AOO = 'aoo_keyinfo',
  W9 = 'w9_keyinfo',
  // FEIN = 'FEIN',
  FEDERAL_1120 = 'federal1120_keyinfo',
  FEDERAL_1065 = 'form1065_keyinfo',
};

export const fileUploadDefaults = {
  accept: {
    'text/csv': ['.csv'],
    'image/jpeg': ['.jpeg', '.jpg'],
    'image/png': ['.png'],
    'application/pdf': ['.pdf'],
    'text/plain': ['.txt'],
    'application/vnd.ms-excel': ['.xls']
  }
}

export const config_dict: any = {
  "IEP": ["brand_stage","SI","EGO","Gap","Activity"],
  "brand_stage": ["IEP"],
  "SI_name": ["SI"],
  "SI": ["IEP","SI_name","EGO"],
  "EGO_name": ["EGO"],
  "EGO": ["IEP","SI","Gap","EGO_name"],
  "Gap_name": ["Gap"],
  "Gap": ["IEP","EGO","Gap_name","gap_priority","Activity"],
  "gap_priority": ["Gap"],
  "Activity ": ["IEP","Gap","activity_type","study_id"],
  "activity_type": ["Activity"],
  "study_id": ["Activity","compound_generic_name","primary_compound_name","indication","therapeutic_area","study_title","study_type","study_sub_type","planned_patients","approval_actual_date","approval_planned_date","contract_actual_date","contract_planned_date","fpfv_actual_date","fpfv_planned_date","lpfv_actual_date","lpfv_planned_date","lplv_planned_date","lplv_actual_date","actual_paitent_enrolled","total_budget","budget_remaining","current_year_budget_amount","next_year_budget_amount","april_total_fund_budget","april_current_year_budget","study_phase","study_status","sponsor","finance_rollup","nrdg_study_grouping","current_milestone_status","risk_status","risk_type","country","market","country_code"],
  "compound_generic_name": ["study_id"],
  "primary_compound_name": ["study_id"],
  "indication": ["study_id"],
  "therapeutic_area": ["study_id"],
  "study_title": ["study_id"],
  "study_type": ["study_id"],
  "study_sub_type": ["study_id"],
  "planned_patients": ["study_id"],
  "approval_actual_date": ["study_id"],
  "approval_planned_date": ["study_id"],
  "contract_actual_date": ["study_id"],
  "contract_planned_date": ["study_id"],
  "fpfv_actual_date": ["study_id"],
  "fpfv_planned_date": ["study_id"],
  "lpfv_actual_date": ["study_id"],
  "lpfv_planned_date": ["study_id"],
  "lplv_planned_date": ["study_id"],
  "lplv_actual_date": ["study_id"],
  "actual_paitent_enrolled": ["study_id"],
  "total_budget": ["study_id"],
  "budget_remaining": ["study_id"],
  "current_year_budget_amount": ["study_id"],
  "next_year_budget_amount": ["study_id"],
  "april_total_fund_budget": ["study_id"],
  "april_current_year_budget": ["study_id"],
  "study_phase": ["study_id"],
  "study_status": ["study_id"],
  "sponsor": ["study_id"],
  "finance_rollup": ["study_id"],
  "nrdg_study_grouping": ["study_id"],
  "current_milestone_status": ["study_id"],
  "risk_status": ["study_id"],
  "risk_type": ["study_id"],
  "country": ["study_id"],
  "market": ["study_id"],
  "country_code": ["study_id"]
}